import React from 'react';


export default class Select extends React.Component {
  constructor(props) {
    super(props);
    let def = this.props.default ? this.props.default : false;
    let val = this.props.value ? this.props.value : def;
    this.state = {
      options: [],
      value: val
    };
  }

  componentDidUpdate(prevProp, prevState){
    let optionsChanged = false;
    let prePropOp = prevProp.options;
    let propOp = this.props.options;
    if(Array.isArray(this.props.options)){
     prePropOp = prePropOp.join(',');
     propOp = propOp.join(',');
    }
    if(prePropOp != propOp){
      this.setOptions();
      optionsChanged = true;
    }
    if((prevProp.refs !== this.props.refs)||((prevProp.value !== this.props.value)&&(!optionsChanged))){
      this.setState({
        value: this.props.value
      })
    }
  }

  componentDidMount(){
    this.setOptions();
  }

  setOptions = () => {
    // CONSOLE
    let options = this.props.options || [];
    if(!Array.isArray(options))
      options = options.split(',')
    if(options !== this.state.options){
      const optionsValues = options.map(o =>{ return this.optionVal(o)})
      //console.log('OPTIONS '+this.props.name, optionsValues);
      // console.log('VAL '+this.props.name, this.props.value);
      let value = this.props.value;
      let ix = optionsValues.includes(value);
      const outVal = (ix) ? value : this.props.default||false;
      this.setState({
        options: options,
        value: outVal
      },()=>{
        if(this.state.value != outVal){
          this.props.callback({
            refs: this.props.refs,
            ...this.props.refs,
            newData: {
              field: this.props.name,
              value: outVal
            }
          })
        }
      })
    }
  }

  handleChange = (e) => {
    this.setState({
      value: e.target.value
    })
    if(this.props.callback !== null){
      this.props.callback({
          field: this.props.name,
          value: e.target.value,
      })
    }
    e.preventDefault();
  }

  handleFocus(event) {
    event.target.select();
  }

  field = () => {
    let propOp = [...this.state.options];
    let props = {}
    let options = propOp.map((option, index) => {
      let dis = false;
      let val = this.optionVal(option);
      const out = this.optionOutput(option, index)
      if(this.props.disabled){
        dis = (this.props.disabled.includes(val));
        if(dis)
          props.disabled="disabled";
      }
      props.value = val;
      //if(this.state.value == val)
      //  props.selected = "selected";
      return (<option key={"sel-"+index} {...props}>{out}</option>)
    })
    let ph = "";
    if(this.props.label == null){
      ph = (!this.props.placeholder) ? this.props.name : this.props.placeholder;
    }else{
      ph = (!this.props.placeholder) ? null : this.props.placeholder;
    }
    let placeholder = (this.props.placeholder) ? <option value={-1}>{ph}</option> : '';
    //console.log('SELECT', this.state.value)
    return(
      <select
        name={this.props.name}
        key=""
        className="form-control"
        value={this.state.value}
        onChange={this.handleChange}
      >
        {placeholder}
        {options}
      </select>
    )
  }

  render() {
    return (
        <>{this.field()}</> 
    );
  }

  optionOutput = (option, index) => {
    let out = option;
    if(this.props.hasOwnProperty('output')){
      let output = this.props.output;
      if(option.hasOwnProperty(output)){
        out = option[output];
      }else{
        if(output.hasOwnProperty(index))
          out = output[index];
        if(output.hasOwnProperty(option))
          out = output[option];
      }
    }
    return out;
  }

  optionVal = (o) => {
    if(o.hasOwnProperty('_id'))
      o = o._id;
    return o;
  }
}
